/**
 * AB实验页面
 */

export default {
  dbl_ab_experiment_title: "A/B实验分析",
  dbl_ab_experiment_calculate: "计算",
  dbl_ab_experiment_finish_calculate: "终止计算",
  dbl_ab_experiment_not_empty_metric: "指标不能为空",
  dbl_ab_experiment_clear: "清空",
  dbl_ab_experiment_global_filter_title: "通用筛选",
  dbl_ab_experiment_event_filter_title: "事件筛选",
  dbl_ab_experiment_experiment_cascade_title: "实验筛选",
  dbl_ab_experiment_metric_filter_title: "指标",
  dbl_ab_experiment_dimension_filter_title: "维度",
  dbl_ab_experiment_observation_settings_title: "观测设置",
  dbl_ab_experiment_observation_days: "观测天数",
  dbl_ab_experiment_observation_days_exceeds_max: "超过最大值（最大为 {max}）",
  dbl_ab_experiment_limit: "Limit",
  dbl_ab_experiment_global_filter_add_button: "添加通用筛选",
  dbl_ab_experiment_event_filter_add_button: "添加事件筛选",
  dbl_ab_experiment_experiment_cascade_add_button: "添加实验筛选",
  dbl_ab_experiment_experiment_cascade_remove_filter: "删除筛选器",
  dbl_ab_experiment_metric_filter_add_button: "添加统计指标",
  dbl_ab_experiment_metric_filter_add_custom_button: "添加自定义指标",
  dbl_ab_experiment_metric_filter_custom_placeholder: "请选择自定义指标",
  dbl_ab_experiment_dimension_filter_add_button: "添加维度",
  dbl_ab_experiment_event_filter_placeholder: "请选择事件",
  dbl_ab_experiment_event_filter_placeholder_all_event: "全部事件",
  dbl_ab_experiment_event_filter_edit_name: "编辑名称",
  dbl_ab_experiment_event_filter_delete: "删除",
  dbl_ab_experiment_user_type_title: "用户类型",
  dbl_ab_experiment_user_type_active_user: "活跃用户",
  dbl_ab_experiment_user_type_new_user: "新用户",
  dbl_ab_experiment_user_type_old_user: "老用户",
  dbl_ab_experiment_date_range_title: "统计日期",
  dbl_ab_experiment_abtest_cascader_experiment_layer: "实验层",
  dbl_ab_experiment_abtest_cascader_experiment_name: "实验名称",
  dbl_ab_experiment_abtest_cascader_experiment_group: "实验分组",
  dbl_ab_experiment_abtest_cascader_placeholder: "请选择实验",
  dbl_ab_experiment_abtest_cascader_search_placeholder: "搜索",
  dbl_ab_experiment_event_occur_label: "事件发生",
  dbl_ab_experiment_event_occur_placeholder: "请选择",
  dbl_ab_experiment_event_occur_option_event_count: "发生的次数",
  dbl_ab_experiment_event_occur_option_user_count: "发生的人数",
  dbl_ab_experiment_event_occur_option_reach_rate: "触达率",
  dbl_ab_experiment_event_occur_count_label: "事件发生次数",
  dbl_ab_experiment_event_occur_count_error: "请输入整数且最大值不小于最小值",
  dbl_ab_experiment_event_occur_operator_placeholder: "请选择条件",
  dbl_ab_experiment_empty_guide_title: "操作指引:",
  dbl_ab_experiment_empty_guide_step1: "1. 请在左侧区域选择指标,并设置观测天数",
  dbl_ab_experiment_empty_guide_step2: "2. (选填)通用筛选、事件筛选、实验筛选、维度按需设置",
  dbl_ab_experiment_empty_guide_step3: "3. 配置完成后,点击【计算】",
  dbl_ab_experiment_calculate_error: "计算失败，错误码 {code}",
  dbl_ab_experiment_load_task_error: "加载任务详情失败，错误码 {code}",
  dbl_ab_experiment_leave_info: "离开当前分析任务？",
  dbl_ab_experiment_preview_sql: "预览 SQL",
  dbl_ab_experiment_preview_sql_copy: "复制",
  dbl_ab_experiment_preview_sql_fail: "预览 SQL 失败",
  dbl_ab_experiment_preview_sql_fail_with_code: "预览 SQL 失败，错误码 {code}",
};
